module.exports = __webpack_public_path__ + "static/media/ic-business-selected.4cf70eed.svg";